import {
  CHANGE_ALLOWED_DOMAINS,
  CHANGE_DMARC_FOR_PARTNERS,
  CHANGE_ENFORCE_MAILBOXES_LIMIT,
  CHANGE_EXPIRATION_DATE,
  CHANGE_MAILBOX_LIMIT,
  CHANGE_PLAN,
  CHANGE_SILENT_MODE_STATUS,
  CHANGE_TRIAL_EXPIRATION,
  CHANGE_TRIAL_PLAN,
  EDIT_TENANT_APPLY_ASYNC,
  FETCH_TENANT_DATA,
  TOGGLE_ADDON,
  TOGGLE_AUTOPILOT,
} from './constants'

export default function () {
  const initialState = {
    data: {},
    loader: false,
    error: null,
    originalData: {},
    mapSelectedAddons: {},
    originalMapSelectedAddons: {},
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case TOGGLE_ADDON:
        return {
          ...state,
          mapSelectedAddons: {
            ...state.mapSelectedAddons,
            [action.payload.addonName]: !state.mapSelectedAddons[action.payload.addonName],
          },
        }
      case CHANGE_ALLOWED_DOMAINS:
        return {
          ...state,
          data: {
            ...state.data,
            allowedDomains: action.payload.value,
          },
        }
      case CHANGE_PLAN: {
        const relevantAddons = state.data.addons[action.payload.value] || {}
        const hasChangedPlan = state.originalData.planType !== action.payload.value
        const mapSelectedAddons = Object.values(relevantAddons).reduce((acc, addon) => {
          acc[addon.name] = hasChangedPlan ? addon.activeByDefault : addon.currentState
          return acc
        }, {})
        return {
          ...state,
          data: {
            ...state.data,
            planType: action.payload.value,
          },
          mapSelectedAddons,
          originalMapSelectedAddons: { ...mapSelectedAddons },
        }
      }
      case CHANGE_MAILBOX_LIMIT:
        return {
          ...state,
          data: {
            ...state.data,
            mailboxLimit: action.payload.value,
          },
        }
      case CHANGE_DMARC_FOR_PARTNERS:
        return {
          ...state,
          data: {
            ...state.data,
            enableDmarcForPartnersProps: {
              ...state.data.enableDmarcForPartnersProps,
              value: action.payload.value,
            }
          },
        }
      case CHANGE_EXPIRATION_DATE:
        return {
          ...state,
          data: {
            ...state.data,
            planExpiration: action.payload.value,
          },
        }
      case CHANGE_SILENT_MODE_STATUS:
        return {
          ...state,
          data: {
            ...state.data,
            silentMode: action.payload.value,
          },
        }
      case TOGGLE_AUTOPILOT:
        return {
          ...state,
          data: {
            ...state.data,
            isAutopilotEnabled: !state.data.isAutopilotEnabled,
          },
        }
      case CHANGE_TRIAL_EXPIRATION:
        return {
          ...state,
          data: {
            ...state.data,
            trialExpiration: action.payload.value,
          },
        }
      case CHANGE_TRIAL_PLAN:
        return {
          ...state,
          data: {
            ...state.data,
            trialPlanType: action.payload.value,
          },
        }
      case CHANGE_ENFORCE_MAILBOXES_LIMIT:
        return {
          ...state,
          data: {
            ...state.data,
            enforceMailboxesLimit: action.payload.value,
          },
        }
      case FETCH_TENANT_DATA.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case FETCH_TENANT_DATA.SUCCESS: {
        const { data } = action.payload
        const relevantAddons = data.addons[data.planType] || {}
        const mapSelectedAddons = Object.values(relevantAddons).reduce((acc, addon) => {
          acc[addon.name] = addon.currentState
          return acc
        }, {})
        return {
          ...state,
          loader: false,
          data,
          originalData: data,
          mapSelectedAddons,
          originalMapSelectedAddons: { ...mapSelectedAddons },
        }
      }
      case FETCH_TENANT_DATA.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
        }
      case FETCH_TENANT_DATA.CANCEL:
        return {
          ...state,
          data: {},
          loader: false,
          error: null,
          originalData: {},
        }
      case EDIT_TENANT_APPLY_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case EDIT_TENANT_APPLY_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            ...action.payload.data,
          },
        }
      case EDIT_TENANT_APPLY_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
        }
      case EDIT_TENANT_APPLY_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          error: null,
        }
      default:
        return state
    }
  }
}
